import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global-styles.css';
import { Home } from './templates/Home';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Publicar from './templates/Home/publicar';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <Home />
//   </React.StrictMode>
// );
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        {/* Define as rotas */}
        <Route path="/" element={<Home />} />
        <Route path="/publicar" element={<Publicar />} />
      </Routes>
    </Router>
  </React.StrictMode>
);